import { setVisibility, setVisibilityFalse } from '../components/investors/additionalKYCDetails';
import { IndividualAdditionalKYC, investorKycQuestionMdsm } from '../redux-store/types/api-types';

export default function updateVisibility(
  answer: string | string[],
  q: Partial<IndividualAdditionalKYC>,
  formValues: investorKycQuestionMdsm,
  applicantIndex: number
): void {
  if (q.question_type === 'multipleSelect' || q.question_type === 'multiSelectCheckBox') {
    const incudedAns = q.options
      ?.filter((e) => {
        return answer.includes(e.key);
      })
      .map((e) => e.showQs)
      .flat();

    const excludedAns = q.options
      ?.filter((e) => {
        return !answer.includes(e.key);
      })
      .map((e) => {
        if (e.hideQs && e.hideQs.length > 0) {
          return [...e.hideQs, ...(e.showQs || [])]?.sort();
        } else {
          return e.showQs;
        }
      })
      .flat();

    incudedAns?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibility(qns as string, ques, formValues, applicantIndex);
      });
    });
    excludedAns?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibilityFalse(qns as string, ques, formValues, applicantIndex);
      });
    });
  }

  if (q.question_type === 'single_choice_radio' || q.question_type === 'selectField') {
    const filteredOption = q.options?.filter((option) => option.key === answer);

    const showQs =
      filteredOption && filteredOption?.length > 0 ? filteredOption[0].showQs || [] : [];
    const hideQs =
      filteredOption && filteredOption?.length > 0 ? filteredOption[0].hideQs || [] : [];
    showQs?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibility(qns, ques, formValues, applicantIndex);
      });
    });
    hideQs?.forEach((qns) => {
      formValues.forEach((ques) => {
        setVisibilityFalse(qns, ques, formValues, applicantIndex);
      });
    });
  }
}
